import React from "react";
import { Row, Col, MenuItem, DropdownButton, ButtonToolbar, Button, Grid, ToggleButtonGroup, ToggleButton } from 'react-bootstrap'
import Filter from "../Filter/Filter";
import ProductItem from "../ProductItem/ProductItem";
import ProductItemGrid from "../ProductItemGrid/ProductItemGrid";
import ShopSort from "../ShopSort/ShopSort";
import PopularProducts from "../PopularProducts/PopularProducts";
import GridProducts from "../GridProducts/GridProducts";
import Paginations from "../Paginations/Paginations";
import ListProducts from "../ListProducts/ListProducts";

class Shop extends React.Component {

    constructor() {
        super()
        this.settingView=this.settingView.bind(this);
        this.state = {
            view: 'grid',
        }
    }

    settingView(newView){
        this.setState({view:newView})
    }
    render() {
        return (


            <div className="products">
                <Grid>
                    <Col md={3}>
                        <Filter />
                    </Col>
                    <Col md={9}>
                        <ShopSort settingView={this.settingView}/>

                        <Row>
                            {this.state.view ==='grid'?
                            <GridProducts/>
                            :
                            <ListProducts />
                            }
                        </Row>

                    </Col>
                    <Paginations />

                </Grid>

                <div>
                    <PopularProducts />
                </div>

            </div>
        );
    }
}
export default Shop;


// WEBPACK FOOTER //
// ./src/Components/Shop/Shop.jsx